// Host apps that may embed this app (comma separated in .env)
export const HOST_ORIGINS = (process.env.REACT_APP_HOST_ORIGINS || "")
  .split(",")
  .map((s) => s.trim())
  .filter(Boolean);

const FLAG = "eplan-embedded";
const TOKEN_TIMEOUT_MS = 15000;

let token = null;
let tenantId = null;
let hostOrigin = null;
let waiters = [];
const listeners = new Set();

const detectEmbedded = () => {
  if (window.self === window.top) return false;
  const hasParam = new URLSearchParams(window.location.search).has("embedded");
  try {
    if (hasParam) sessionStorage.setItem(FLAG, "1");
    return hasParam || sessionStorage.getItem(FLAG) === "1";
  } catch {
    return hasParam; // storage blocked
  }
};
// Evaluated once at load: router navigation inside the iframe must not change it
const EMBEDDED = detectEmbedded();
export const isEmbedded = () => EMBEDDED;

const expiresSoon = () => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return payload.exp * 1000 - Date.now() < 20000;
  } catch {
    return true;
  }
};

// Call once before rendering; resolves when the host sent the first token
export function startEmbeddedAuth() {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(
      () => reject(new Error("Host app did not send a token")),
      TOKEN_TIMEOUT_MS
    );

    window.addEventListener("message", (e) => {
      if (!HOST_ORIGINS.includes(e.origin) || e.source !== window.parent) return;
      if (e.data?.type !== "auth:token") return;

      hostOrigin = e.origin;
      token = e.data.token;
      tenantId = e.data.tenantId;
      waiters.forEach((w) => w(token));
      waiters = [];
      listeners.forEach((cb) => cb(token));
      clearTimeout(timer);
      resolve();
    });

    // The parent origin is not known yet: announce to each allowed host
    HOST_ORIGINS.forEach((o) => window.parent.postMessage({ type: "embed:ready" }, o));
  });
}

export async function getEmbeddedToken() {
  if (token && !expiresSoon()) return token;
  return new Promise((resolve) => {
    waiters.push(resolve);
    window.parent.postMessage({ type: "auth:request" }, hostOrigin);
  });
}

export const onEmbeddedToken = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

export const getEmbeddedTenant = () => tenantId;
export const getHostOrigin = () => hostOrigin;